/* eslint-disable react/prop-types */
import { Layout } from "antd";
const { Content } = Layout;

interface SetupLayoutProps {
  children: React.ReactNode;
}

export const SetupLayout: React.FC<SetupLayoutProps> = ({ children }) => (
  <Content>{children}</Content>
);
